import { ProcessingIconDashed } from 'components/icons/icons';

const CountLabel = ({ loading, length = 0, singularLabel = '', pluralLabel = '' }) => {
  if (loading) {
    return (
      <span className="flex items-center gap-2">
        <ProcessingIconDashed className="spin" />
        Loading {pluralLabel?.toLowerCase()}...
      </span>
    );
  }

  return (
    <>
      {length} {length === 1 ? singularLabel : pluralLabel}
    </>
  );
};

export default CountLabel;
